import { createSvgIcon } from '@mui/material/utils'

const Butler = createSvgIcon(
  <>
    <path opacity="0.15" d="M59.5424 47.7578H23.3608V50.5052H59.5424V47.7578Z" fill="#183A9E" />
    <path opacity="0.15" d="M54.2768 42.2632H28.6265V45.0105H54.2768V42.2632Z" fill="#183A9E" />
    <path
      opacity="0.15"
      d="M41.4517 34.0211V0.397461H54.2769V21.1959C54.2768 24.5973 52.9256 27.8595 50.5204 30.2647C48.1152 32.6698 44.8531 34.0211 41.4517 34.0211V34.0211Z"
      fill="#183A9E"
    />
    <path
      d="M41.4514 34.4188C37.9457 34.4149 34.5848 33.0206 32.1058 30.5417C29.6269 28.0629 28.2325 24.7019 28.2285 21.1963V0H54.6743V21.1963C54.6703 24.7019 53.2758 28.0629 50.7969 30.5417C48.318 33.0206 44.957 34.4149 41.4514 34.4188V34.4188ZM29.0239 0.795361V21.1963C29.0239 24.4923 30.3332 27.6532 32.6638 29.9839C34.9944 32.3145 38.1554 33.6238 41.4514 33.6238C44.7474 33.6238 47.9084 32.3145 50.239 29.9839C52.5696 27.6532 53.8789 24.4923 53.8789 21.1963V0.795361H29.0239Z"
      fill="#3260E2"
    />
    <path
      d="M59.9399 50.9026H22.9634V44.6123H59.9399V50.9026ZM23.7587 50.1072H59.1445V45.4077H23.7587V50.1072Z"
      fill="#3260E2"
    />
    <path
      d="M54.6743 45.408H28.2285V39.1182H54.6743V45.408ZM29.0239 44.6127H53.8789V39.9135H29.0239V44.6127Z"
      fill="#3260E2"
    />
    <path d="M41.8496 34.021H41.0542V39.5159H41.8496V34.021Z" fill="#3260E2" />
    <path
      d="M28.6264 21.5942C25.2788 21.5904 22.0695 20.2589 19.7024 17.8918C17.3353 15.5247 16.0038 12.3154 16 8.96783V4.47412H28.6264V5.26948H16.7954V8.96783C16.7989 12.1045 18.0465 15.1117 20.2645 17.3297C22.4825 19.5477 25.4897 20.7953 28.6264 20.7988V21.5942Z"
      fill="#3260E2"
    />
    <path
      d="M54.2769 21.5942V20.7988C57.4135 20.7953 60.4208 19.5477 62.6387 17.3297C64.8567 15.1117 66.1043 12.1045 66.1078 8.96783V5.26948H54.2769V4.47412H66.9032V8.96783C66.8994 12.3154 65.5679 15.5247 63.2008 17.8918C60.8338 20.2589 57.6244 21.5904 54.2769 21.5942Z"
      fill="#3260E2"
    />
    <path
      fill="none"
      d="M77.664 56.117H6.11613C3.24801 56.117 1 53.7911 1 51H82.8576C82.7801 53.7911 80.5321 56.117 77.664 56.117Z"
      stroke="#3260E2"
      strokeWidth="0.813747"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M19.9131 56.1226L35.2614 81.0874L42.0053 96.8262C42.0053 96.8262 53.8654 95.4306 59.214 88.0652L57.1986 83.801C57.1986 83.801 61.6945 77.0558 61.9271 62.9453C61.9271 62.9453 63.5549 60.0766 67.6633 57.7507C66.8881 56.7428 65.6479 56.2001 64.4076 56.2001H59.6791L50.6872 66.8993L48.3617 66.9769L46.1912 65.5813L42.7029 56.2001H37.9744L39.2147 65.8139L29.5251 56.2001H19.9131V56.1226Z"
      stroke="#3260E2"
      strokeWidth="0.813747"
      strokeMiterlimit="10"
    />
    <path
      fill="none"
      d="M46.9666 78.9166C46.9666 78.9166 41.9281 72.2489 35.1841 68.2173L24.7969 56.1226"
      stroke="#3260E2"
      strokeWidth="0.813747"
      strokeMiterlimit="10"
    />
    <path
      fill="none"
      d="M57.1215 83.7222C57.1215 83.7222 53.0131 88.4515 46.9668 90.3123"
      stroke="#3260E2"
      strokeWidth="0.813747"
      strokeMiterlimit="10"
    />
    <path
      fill="none"
      d="M59.1382 87.9829L63.0141 95.5809L46.8131 103.644L43.0923 96.5888"
      stroke="#3260E2"
      strokeWidth="0.813747"
      strokeMiterlimit="10"
    />
    <path
      fill="none"
      d="M74.3308 117.291L63.0134 95.5825L41.0762 106.437L44.6419 117.291"
      stroke="#3260E2"
      strokeWidth="0.813747"
      strokeMiterlimit="10"
    />
  </>,
  'Butler'
)

export default Butler
